const predefinedTranslations = {
  Open: 'All',
  Closed: 'All',
  Snoozed: 'All',
  Unread: 'All Unread',
  Deleted: 'All Deleted',
  Spam: 'All Spam',

  'My Closed': 'Mine',
  'My Snoozed': 'Mine',
}

const throwouts = [
  /^All of /,
  /^All in /,
  /^All /,
  / ?Open/,
  / ?Closed/,
  / ?Snoozed/,
]

/**
 * SN: Hack-ish way to show pretty title in conversation header only, and not in
 * other places where we could use search names (e.g. pinned searches bar)
 */
export function translate(title) {
  if (predefinedTranslations[title]) return predefinedTranslations[title]

  const newTitle = throwouts.reduce(
    (titleSoFar, throwout) => titleSoFar.replace(throwout, ''),
    title || ''
  )

  return newTitle
}
